export default __webpack_public_path__ + "static/media/Punto_01_Porto_Mediceo_DEU_Def.39dbc22c.aac";